var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MlInput',{attrs:{"placeholder":_vm.placeholder,"value":_vm.comma(_vm.inputValue),"readonly":_vm.readonly,"max":15,"isPrint":_vm.isPrint,"visibleCounter":_vm.visibleCounter,"textAlign":"right","noneCount":","},on:{"input":(value) => {
      _vm.inputValue = _vm.removeComma(value);
    },"keyup":(value) => _vm.$emit('keyup', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }